import { t } from "i18next";
import { ReactComponent as KoreroLogoSvg } from "../../images/korero-logo-white.svg";

export const PoweredByKorero = () => {
  return (
    <div id="nav-powered-by">
      <div className="text-center mb-1">{t("Common.PoweredBy")}</div>
      <a
        className="flex flex-row justify-center"
        href="https://www.hellokorero.co/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <KoreroLogoSvg className="max-h-12" />
      </a>
    </div>
  );
};
